const STORAGE_KEY = "printerSettings";

export const defaultPrinterSettings = {
    receiptPrinter: "",
    invoicePrinter: "",
    labelPrinter: "",
    defaultPrinter: ""
};

export const getPrinterSettings = () => {
    try {
        const data = localStorage.getItem(STORAGE_KEY);

        return data
            ? JSON.parse(data)
            : defaultPrinterSettings;
    } catch {
        return defaultPrinterSettings;
    }
};

export const savePrinterSettings = (settings) => {
    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(settings)
    );
};